import type { ReactNode } from 'react';
import { useState } from 'react';
import { impossible } from 'common/types/impossible';

type Props = {
  renderToggle: (arg: { open: () => void }) => ReactNode;
  renderModal: (arg: { close: () => void }) => ReactNode;
};
type Closed = {
  status: 'CLOSED';
};
type Open = {
  status: 'OPEN';
};
type State = Closed | Open;

const open: Open = { status: 'OPEN' };
const closed: Closed = { status: 'CLOSED' };

export function ModalToggle(props: Props): ReactNode {
  const [modal, setModal] = useState<State>(closed);

  switch (modal.status) {
    case 'CLOSED':
      return <div>{props.renderToggle({ open: () => setModal(open) })}</div>;
    case 'OPEN':
      return (
        <div>
          {props.renderToggle({ open: () => {} })}
          {props.renderModal({ close: () => setModal(closed) })}
        </div>
      );
    default:
      return impossible(modal);
  }
}
